export const isProductOutOfStock = (product = {}) => {
    return product.StockAvailable === false;
};

export const getProductStockLabel = (product = {}) => {
    if (isProductOutOfStock(product)) {
        return product.stockLabel || product.stock_label || "Out of stock";
    }
    return "";
};
